var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',[_c('a',{attrs:{"href":_vm.mmUrl},on:{"click":function($event){$event.preventDefault();_vm.getMareiMekomos()}}},[_c('i',{staticClass:"fa fa-fw fa-paperclip"})])])}
var staticRenderFns = []

export { render, staticRenderFns }